import { render, staticRenderFns } from "./PanelLayout.vue?vue&type=template&id=4945d570&scoped=true&"
import script from "./PanelLayout.vue?vue&type=script&lang=js&"
export * from "./PanelLayout.vue?vue&type=script&lang=js&"
import style0 from "./PanelLayout.vue?vue&type=style&index=0&id=4945d570&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4945d570",
  null
  
)

export default component.exports